export default {
  true: 'Yes',
  false: 'No',
  gender: {
    male: 'Male',
    female: 'Female',
  },
};
